import { memo } from 'react';
import SectionIcon from '../../../../shared/components/SectionIcon';
import CategoryName from './CategoryName';
import { getSectionName } from 'utils/getSectionName';
import { testIds } from 'core/testIds';

import { TabItem, TabIcon, TabLabel } from './NavigationStyles';

interface NavigationTabProps {
  sectionName: string;
  isActive: boolean;
  isDisabled: boolean;
  onClick: () => void;
  tabRefs: React.RefObject<Map<string, HTMLDivElement>>;
  isLobbyTab?: boolean;
}

const NavigationTab = memo(
  function NavigationTab({
    sectionName: name,
    isActive,
    isDisabled,
    onClick,
    tabRefs,
    isLobbyTab = false,
  }: NavigationTabProps) {
    // Temporarily map TOP to TOP_GAMES
    const sectionName = getSectionName(name);

    return (
      <TabItem
        key={sectionName}
        ref={(el) => {
          if (el) {
            tabRefs.current.set(sectionName, el);
          } else {
            tabRefs.current.delete(sectionName);
          }
        }}
        $isActive={isActive}
        $isDisabled={isDisabled}
        onClick={!isDisabled ? onClick : undefined}
        data-lobby-tab={isLobbyTab}
        data-testid={testIds.navigation.tabButton(sectionName, isActive ? 'active' : 'inactive')}
      >
        <TabIcon $isActive={isActive}>
          <SectionIcon sectionName={name} isActive={isActive} />
        </TabIcon>
        <TabLabel $isActive={isActive} data-testid={testIds.navigation.tabLabel(sectionName)}>
          <CategoryName categoryKey={sectionName} />
        </TabLabel>
      </TabItem>
    );
  },
  (prevProps, nextProps) => {
    // Re-render only if relevant props change
    return (
      prevProps.sectionName === nextProps.sectionName &&
      prevProps.isActive === nextProps.isActive &&
      prevProps.isDisabled === nextProps.isDisabled &&
      prevProps.isLobbyTab === nextProps.isLobbyTab
    );
  },
);

export default NavigationTab;
